import React, { useEffect, useState } from 'react';

import { Container, Button } from 'react-bootstrap';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
    getAuth,
    onAuthStateChanged,
    signOut
} from "firebase/auth";

import { firebaseConfig } from './firebase/firebaseConfig'


function Home() {

    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);
    const auth = getAuth();

    const [isLogin, setIsLogin] = useState('isLogin');
    const [loginEmail, setLoginEmail] = useState('loginEmail');

    const checkLogin = () => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User
                const uid = user.uid;
                // ...
                setIsLogin(true);
                setLoginEmail(user.email);
            } else {
                // User is signed out
                // ...
                setIsLogin(false);
            }
        });
    }

    const logoutUser = () => {
        signOut(auth).then(() => {
            // Sign-out successful.
            setIsLogin(false);
        }).catch((error) => {
            // An error happened.
        });
    }

    useEffect(() => {
        checkLogin();
    });

    let showText = [];
    if (isLogin) {
        showText = (
            <div>
                Hello, {loginEmail} <br /><br />
                <>
                    <Button variant="primary" onClick={logoutUser}>登出</Button>
                </>
            </div>
        );
    } else {
        showText = (
            <div>
                未登入
            </div>
        );
    }

    return (
        <Container style={{ padding: '20px' }}>
            {showText}
        </Container>
    );
}

export default Home;